import { BOOKING_STEP_MINUTES } from '@pages/Calendar/data';

import { formatTime, toMinutes } from './appointmentDragUtils';

interface GetCalendarGridStepHeightParams {
  intervalHeightPx: number;
  stepMinutes: number;
}

export const getCalendarPixelsPerMinute = (intervalHeightPx: number): number =>
  intervalHeightPx / BOOKING_STEP_MINUTES;

export const getCalendarGridStepHeight = ({
  intervalHeightPx,
  stepMinutes,
}: GetCalendarGridStepHeightParams): number =>
  getCalendarPixelsPerMinute(intervalHeightPx) * stepMinutes;

// Aligns a HH:mm time to the nearest step boundary measured from 00:00.
// Needed so timeline marks and grid rows always land on natural hour/half-hour
// boundaries (otherwise 60-min mode with a non-hour start hides hour ticks).
export const snapTimeToStep = (
  time: string,
  stepMinutes: number,
  mode: 'floor' | 'ceil'
): string => {
  if (stepMinutes <= 0) {
    return time;
  }

  const totalMinutes = toMinutes(time);
  const snapped =
    mode === 'floor'
      ? Math.floor(totalMinutes / stepMinutes) * stepMinutes
      : Math.ceil(totalMinutes / stepMinutes) * stepMinutes;

  return formatTime(snapped);
};
